import {Component, ElementRef, ViewChild} from '@angular/core';
import {ItemBase} from "../item-base";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-navbar-item-small',
  templateUrl: './navbar-item-small.component.html',
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  styleUrls: ['./navbar-item-small.component.scss']
})
export class NavbarItemSmallComponent extends ItemBase {
  @ViewChild('item') item!: ElementRef;
}
